<form [formGroup]="form">
  <div class="row">
    <!-- Cliente -->
    <div class="col-12 mb-2" *ngIf="storageService.isAdmin()">
      <span>{{ "tables.client" | translate }}</span>
      <app-spinner [smallLoader]="true" *ngIf="loadingClients"></app-spinner>
      <ng-container *ngIf="!loadingClients">
        <app-search-select
          [items]="clients"
          [displayKey]="'name'"
          [valueKey]="'id'"
          [placeholder]="'admin.admins.select-client' | translate"
          formControlName="client"
          (itemSelected)="getFarms($event ? $event.id : null)"
        >
        </app-search-select>
      </ng-container>
    </div>

    <!-- Granja -->
    <div class="col-12 mb-2">
      <span>{{ "general.farm" | translate }}</span>
      <app-spinner [smallLoader]="true" *ngIf="loadingFarms"></app-spinner>
      <ng-container *ngIf="!loadingFarms">
        <select
          class="form-control"
          formControlName="farm"
          (change)="getPonds($event.target.value)"
          *ngIf="farms.length > 0"
        >
          <option value="">{{ "feeder.select-farm" | translate }}</option>
          <option *ngFor="let item of farms" [value]="item.id">{{ item.name }}</option>
        </select>
        <p class="text-muted mb-0" *ngIf="farms.length === 0">
          {{ "feeder.no-farms" | translate }}
        </p>
      </ng-container>
    </div>

    <!-- Estanque -->
    <div class="col-12 mb-2">
      <span>{{ "tables.ponds" | translate }}</span>
      <app-spinner [smallLoader]="true" *ngIf="loadingPonds"></app-spinner>
      <ng-container *ngIf="!loadingPonds">
        <select
          class="form-control"
          formControlName="pond"
          *ngIf="ponds.length > 0"
        >
          <option value="">{{ "general.select-pond" | translate }}</option>
          <option *ngFor="let item of ponds" [value]="item.id">{{ item.name }}</option>
        </select>
        <p class="text-muted mb-0" *ngIf="ponds.length === 0">
          {{ "feeder.no-ponds" | translate }}
        </p>
      </ng-container>
    </div>

    <!-- Marca (solo feeders) -->
    <div class="col-12 mb-2" *ngIf="deviceType === 'feeder'">
      <span>{{ "tables.brand" | translate }}</span>
      <app-spinner [smallLoader]="true" *ngIf="loadingBrands"></app-spinner>
      <select class="form-control" formControlName="brand" *ngIf="!loadingBrands">
        <option value="">{{ "feeder.select-brand" | translate }}</option>
        <option *ngFor="let item of brands" [value]="item.id">{{ item.name }}</option>
      </select>
    </div>

    <!-- Dispensador (solo feeders) -->
    <div class="col-12 mb-2" *ngIf="deviceType === 'feeder'">
      <span>{{ "alerts.general.dispenser" | translate }}</span>
      <app-spinner [smallLoader]="true" *ngIf="loadingDispensers"></app-spinner>
      <select class="form-control" formControlName="dispenser" *ngIf="!loadingDispensers">
        <option value="">{{ "feeder.select-dispenser" | translate }}</option>
        <option *ngFor="let item of dispensers" [value]="item.id">{{ item.name }}</option>
      </select>
    </div>

    <!-- Tipo de dispositivo (solo waterwises) -->
    <div class="col-12 mb-2" *ngIf="deviceType === 'waterwise'">
      <span>{{ "update-device-dynamic.device-type" | translate }}</span>
      <select class="form-control" formControlName="device_type">
        <option value="">{{ "form.select-option" | translate }}</option>
        <option *ngFor="let opt of deviceTypeOptions" [value]="opt.value">
          {{ opt.label | translate }}
        </option>
      </select>
    </div>

    <!-- Meses de garantía -->
    <div class="col-12 col-md-6 mb-2">
      <span>{{ "update-device-dynamic.warranty-months" | translate }}</span>
      <input
        type="number"
        class="form-control"
        formControlName="warranty_months"
        min="0"
        [placeholder]="'update-device-dynamic.warranty-months-placeholder' | translate"
      />
    </div>

    <!-- Fecha de inicio de garantía -->
    <div class="col-12 col-md-6 mb-2">
      <span>{{ "update-device-dynamic.warranty-start-date" | translate }}</span>
      <input
        type="date"
        class="form-control"
        formControlName="warranty_start_date"
      />
    </div>
  </div>
</form>

<div class="center mt-3 w-100">
  <button
    class="btn btn-success btn-space"
    [disabled]="loading"
    (click)="register()"
  >
    <app-spinner [smallLoader]="true" *ngIf="loading"></app-spinner>
    <span *ngIf="!loading">{{ "general.finish" | translate }}</span>
  </button>
</div>
